import { combineReducers, configureStore } from "@reduxjs/toolkit";
import aksReducer from "./aksReducer";
import tpmsReducer from "./tpmsReducer";
import idsReducer from "./IdsReducer";
import virtualLoopsReducer from "./virtualLoopsReducer";
import tvEnergyReducer from "./tvEnergyReducer";
import adminReducer from "./adminReducer";
import performanceMetricsReducer from "./performanceMetricsReducer";
import importsReducer from "./importsReducer";
import fpAnalysisReducer from "./fpAnalysisReducer";
import radioReducer from "./radioReducer";
import trackMapReducer from "./trackMapReducer";
import raceDataReducer from "./raceDataReducer";
import replayReducer from "./replayReducer";
import virtualGapsReducer from "./virtualGapsReducer";
import interventionsReducer from "./interventionsReducer";
import permissionsReducer from "./permissionsReducer";
import ressReducer from "./ressReducer";
import attackModeReducer from "./attackModeReducer";
import driverGPSReducer from "./driverGPSReducer";

const combinedReducer = combineReducers({
  admin: adminReducer,
  aks: aksReducer,
  tpms: tpmsReducer,
  ids: idsReducer,
  virtualLoops: virtualLoopsReducer,
  virtualGaps: virtualGapsReducer,
  tvEnergy: tvEnergyReducer,
  performanceMetrics: performanceMetricsReducer,
  imports: importsReducer,
  fpAnalysis: fpAnalysisReducer,
  radio: radioReducer,
  trackMap: trackMapReducer,
  raceData: raceDataReducer,
  ress: ressReducer,
  interventions: interventionsReducer,
  replay: replayReducer,
  permissions: permissionsReducer,
  attackMode: attackModeReducer,
  driverGPS: driverGPSReducer,
});

export const rootReducer = (
  state: ReturnType<typeof combinedReducer> | undefined,
  action: { type: string },
) => {
  if (action.type === "app/reset") {
    const previousState =
      state ?? combinedReducer(undefined, { type: "@@INIT" });

    // Don't reset the permissions state, since it will cause problems with retaining access to the current page
    return {
      ...combinedReducer(undefined, { type: "@@INIT" }),
      permissions: previousState.permissions,
    };
  }
  return combinedReducer(state, action);
};

export const store = configureStore({
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      immutableCheck: { warnAfter: 128 },
      serializableCheck: { warnAfter: 128 },
    }),
  reducer: rootReducer,
});

export const resetApp = () => ({ type: "app/reset" });

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
